/* esm.sh - react-remove-scroll@2.7.2/dist/es2015/medium */
export * from "/*react-remove-scroll@2.7.2/esnext/dist/es2015/medium.mjs";
